<template>
  <v-expansion-panels
    v-model="panels"
    multiple
    accordion
    flat
  >
    <v-expansion-panel :disabled="(!parcel || config.hideParcelsInfos) && (!features || !features.length)">
      <v-expansion-panel-header class="text-h6">
        Sélection
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <selected-infos />
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-divider />
      <v-expansion-panel-header class="text-h6">
        Recherche
      </v-expansion-panel-header>
      <v-expansion-panel-content dense>
        <filters />
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel v-if="hasLegend">
      <v-divider />
      <v-expansion-panel-header class="text-h6">
        Légende
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <map-legend :dense="windowHeight < 600" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import SelectedInfos from './sections/selected-infos.vue'
import Filters from './sections/filters.vue'
import MapLegend from './sections/map-legend.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    SelectedInfos,
    Filters,
    MapLegend
  },
  data: () => ({
    panels: []
  }),
  computed: {
    ...mapState(['parcel', 'features']),
    ...mapGetters(['config']),
    hasLegend () {
      return this.config && this.config.colorField && this.config.colorField.length
    }
  },
  watch: {
    parcel (value) {
      if (value) {
        const array = [0]
        if (this.panels.includes(2)) array.push(2)
        this.panels = array
      } else this.panels = this.panels.filter(v => v)
    },
    features (value) {
      if (value && value.length) {
        const array = [0]
        if (this.panels.includes(2)) array.push(2)
        this.panels = array
      } else this.panels = this.panels.filter(v => v)
    }
  },
  mounted () {
    this.panels = this.hasLegend ? [1, 2] : [1]
  }
}
</script>

<style lang="css" >
.v-expansion-panel-content__wrap {
  padding: 0 12px 12px!important;
}
</style>
